import React from 'react';
import { AclFeaturesList } from '../AclFeaturesList';

const UsersGroupList = () => (
  <AclFeaturesList feature="user_group" apiPrefix="/acls/user-groups" resourceName="user_groups" />
);

export { UsersGroupList };
